import { TypographyNumber } from "@/components/elements/numbers";
import { Badge } from "@/components/ui/badge";
import { TUnreadMessges } from "@/types/public";
const MAX_DISPLAY_COUNT = 99;
export default function UnreadBadge({
  gpId,
  unreadMessges,
}: {
  gpId: string;
  unreadMessges: TUnreadMessges[];
}) {
  const unreadCount =
    unreadMessges.find((item: TUnreadMessges) => item.gp === gpId)?.count || 0;
  if (unreadCount <= 0) {
    return null;
  }
  const displayValue =
    unreadCount > MAX_DISPLAY_COUNT ? `+${MAX_DISPLAY_COUNT}` : unreadCount;
  return (
    <div className="grow flex justify-end flex-shrink-0">
      <Badge className="rounded-full w-5 h-5 p-0 flex items-center justify-center bg-green-500 shadow-lg">
        <TypographyNumber value={displayValue} />
      </Badge>
    </div>
  );
}
